import 'styles/cart/sidebar.scss';

import React from 'react';
import classNames from 'classnames';

import propTypes from 'propTypes';
import PriceSpan from 'common/components/formatters/PriceSpan';
import MembershipLearnMoreModal from 'containers/MembershipLearnMoreModal';
import EmptyCart from './sidebar/EmptyCart';
import UpsellBanner from 'containers/UpsellBanner';
import LineItems from 'containers/LineItems';
import CheckoutButton from 'containers/CheckoutButton';
import OrderSummary from './sidebar/OrderSummary';
import Row from './sidebar/OrderSummaryRow';
import { toggleScrollLock } from 'common/utils';
import { showHeaderOverlay, hideHeaderOverlay } from 'header';
import { TranslatedMessage } from 'common/components/Intl';

export default class Sidebar extends React.Component {
  static propTypes = {
    isOpen: propTypes.bool.isRequired,
    currentOrder: propTypes.OrderWithLineItems.isRequired,
    lineItemsProcessing: propTypes.array.isRequired,
    variants: propTypes.array.isRequired,
    shippingCost: propTypes.number.isRequired,
    totalSavings: propTypes.number.isRequired,
    lineItemsLength: propTypes.number.isRequired,
    mouseEnteredSidebar: propTypes.func.isRequired,
    mouseExitedSidebar: propTypes.func.isRequired,
    toggleVisibility: propTypes.func.isRequired,
    isSubscribableStore: propTypes.bool.isRequired,
  };

  state = {
    shouldToggleScrollLock: false,
  };

  componentWillReceiveProps(newProps) {
    if (this.props.isOpen !== newProps.isOpen) {
      this.setState({ shouldToggleScrollLock: true });
      newProps.isOpen ? showHeaderOverlay() : hideHeaderOverlay();
    }
  }

  componentDidUpdate() {
    if (this.state.shouldToggleScrollLock) {
      toggleScrollLock('.CartSidebar');
      this.setState({ shouldToggleScrollLock: false });
    }
  }

  handleMouseEnter = () => {
    this.props.mouseEnteredSidebar();
  };

  handleMouseLeave = () => {
    this.props.mouseExitedSidebar();
  };

  render() {
    const {
      isOpen,
      currentOrder,
      shippingCost,
      totalSavings,
      lineItemsLength,
      isSubscribableStore,
    } = this.props;
    const isEmpty = lineItemsLength === 0;

    const rootClassNames = classNames('CartSidebar', {
      'CartSidebar--visible': isOpen,
      'CartSidebar--closed': !isOpen,
    });

    let content;
    if (isEmpty) {
      content = <EmptyCart onClickButton={this.props.toggleVisibility} />;
    } else {
      content = <LineItems />;
    }

    const subtotal = parseFloat(currentOrder.total_before_tax);
    const subtotalCents = subtotal * 100;
    const itemQuantity = currentOrder.total_quantity;
    const grandTotal =
      itemQuantity === 0
        ? 0
        : currentOrder.total_before_tax * 100 + shippingCost;
    const grandTotalComponent = <PriceSpan cents={grandTotal} />;

    return (
      <div
        className={rootClassNames}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <MembershipLearnMoreModal />

        <div className="CartSidebar__banner--top">
          <UpsellBanner
            subtotalCents={subtotalCents}
            isSubscribableStore={isSubscribableStore}
          />

          {this.renderErrorBanner()}
        </div>

        {content}

        <OrderSummary
          itemQuantity={itemQuantity}
          subtotalCents={subtotalCents}
          shippingCost={shippingCost}
          totalSavings={totalSavings}
        />

        <div className="CartSidebar__bottom">
          <Row
            label={<TranslatedMessage id={'cart.sidebar.total'} />}
            isShowingBorder={false}
            value={grandTotalComponent}
            isLarge={true}
          />
          <CheckoutButton className="CartSidebar__button--checkout CartSidebar__button--checkout--desktop" />
        </div>

        <CheckoutButton className="CartSidebar__button--checkout CartSidebar__button--checkout--mobile" />
      </div>
    );
  }

  renderErrorBanner = () => {
    const { violations } = this.props.currentOrder;
    if (violations.length > 0) {
      const violation = violations[0];
      return (
        <div className="CartSidebar__banner--error intl-text">{violation}</div>
      );
    }
  };
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/Sidebar.js